import { render, staticRenderFns } from "./vocationalSkills.vue?vue&type=template&id=95846da6&scoped=true"
import script from "./vocationalSkills.vue?vue&type=script&lang=js"
export * from "./vocationalSkills.vue?vue&type=script&lang=js"
import style0 from "./vocationalSkills.vue?vue&type=style&index=0&id=95846da6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95846da6",
  null
  
)

export default component.exports